angular.module('bb.listing.open_houses', ['ngRoute']);

require('./open_houses.routes');
require('./add/open_houses_add.component');
require('./open_houses.service');
